namespace JupitersChoice {
    export class AudioModel {
        private _baseGameAudioTimer: TweenMax;

        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('StateModel') _stateModel: Sapphire.StateModel;


        private _winMusicPlaying: boolean = false;
        private _musicFadedOut: boolean = false;

        public setBaseGameMusicToWinning(){
            if(Sapphire.Browser.isIE || this._stateModel.currentSubgame != 'BaseGame'){
                return;
            }
            if(this._musicFadedOut){
                this._winMusicPlaying = true;
                return;
            }
            if(!this._baseGameAudioTimer){
                //switch over the music now
                this._soundManager.fadeToCurve('ambient_music_level_1', 0, 2000);
                this._soundManager.fadeToCurve('ambient_music_level_2', AudioConstants.BASE_MUSIC_WIN_VOLUME, 2000);
                this._winMusicPlaying = true;
            }
            this.startReturnTimer();
        }

        private startReturnTimer(){
            if(this._baseGameAudioTimer){
                this._baseGameAudioTimer.kill();
            }
            this._baseGameAudioTimer = TweenMax.delayedCall(AudioConstants.BG_WIN_MUSIC_DELAY,() => {
                this._soundManager.fadeToCurve('ambient_music_level_1', AudioConstants.BASE_MUSIC_VOLUME, 2000);
                this._soundManager.fadeToCurve('ambient_music_level_2', 0, 2000);
                this._winMusicPlaying = false
                this._baseGameAudioTimer = null;
            },[],this);
        }

        public returnToBaseGame(){
            if(this._musicFadedOut){
                return;
            }
            this._soundManager.stop('free_spin_music_loop');
            
            if(this._soundManager.isPlaying('ambient_music_level_1')){
                this._soundManager.stop('ambient_music_level_1');
            }

            this._soundManager.play('ambient_music_level_1',null,0);
            if(!Sapphire.Browser.isIE){

                if(this._soundManager.isPlaying('ambient_sfx')){
                    this._soundManager.stop('ambient_sfx');
                }
                this._soundManager.play('ambient_sfx');
                
                if(this._soundManager.isPlaying('ambient_music_level_2')){
                    this._soundManager.stop('ambient_music_level_2');
                }
                this._soundManager.play('ambient_music_level_2',null,0);
            }
            
            
            this._soundManager.fadeToCurve('ambient_music_level_1', AudioConstants.BASE_MUSIC_VOLUME, 1000);
        }

        public switchToFreeSpins(){
            if(this._musicFadedOut){
                return;
            }
            this._soundManager.stop('ambient_sfx');
            this._soundManager.stop('ambient_music_level_1');
            this._soundManager.stop('ambient_music_level_2');

            if(this._soundManager.isPlaying('free_spin_music_loop')){
                this._soundManager.stop('free_spin_music_loop');
            }

            this._soundManager.play('free_spin_music_loop',null,AudioConstants.BASE_MUSIC_VOLUME);
        }

        public fadeOutCurrentMusic(){
            this._musicFadedOut = true;
            if(this._stateModel.currentSubgame == 'BaseGame'){
                this._soundManager.fadeToCurve('ambient_sfx',0,1000);
                this._soundManager.fadeToCurve('ambient_music_level_1', 0, 1000);
                this._soundManager.fadeToCurve('ambient_music_level_2', 0, 1000);
            }else{
                this._soundManager.fadeToCurve('free_spin_music_loop',0,1000);
            }
        }
         
        public fadeInCurrentMusic(){
            this._musicFadedOut = false;
            if(this._stateModel.currentSubgame == 'BaseGame'){
                this._soundManager.fadeToCurve('ambient_sfx',AudioConstants.BASE_SFX_VOLUME,1000);
                if(!this._soundManager.isPlaying('ambient_sfx')){
                    this._soundManager.play('ambient_sfx');
                }
                if(this._winMusicPlaying){
                    this._soundManager.fadeToCurve('ambient_music_level_2', AudioConstants.BASE_MUSIC_WIN_VOLUME, 1000);
                    if(!this._soundManager.isPlaying('ambient_music_level_2')){
                        if(this._soundManager.isPlaying('ambient_music_level_1')){
                            this._soundManager.stop('ambient_music_level_1')
                        }
                        this._soundManager.play('ambient_music_level_1');
                        this._soundManager.play('ambient_music_level_2');
                    }
                    this.startReturnTimer();
                }else{
                    this._soundManager.fadeToCurve('ambient_music_level_1', AudioConstants.BASE_MUSIC_VOLUME, 1000);
                    if(!this._soundManager.isPlaying('ambient_music_level_1')){
                        if(this._soundManager.isPlaying('ambient_music_level_2')){
                            this._soundManager.stop('ambient_music_level_2')
                        }
                        this._soundManager.play('ambient_music_level_1');
                        this._soundManager.play('ambient_music_level_2');
                    }
                }
            }else{
                this._soundManager.fadeToCurve('free_spin_music_loop',AudioConstants.BASE_MUSIC_VOLUME,1000);
                if(!this._soundManager.isPlaying('free_spin_music_loop')){
                    this._soundManager.play('free_spin_music_loop')
                }
            }
        }
    }
}